import users from "./users";

const api = {}

const  headers = {
  "X-Requested-With": "XMLHttpRequest",
  "Content-Type": "application/json"
}

function handler(data){
  return new Promise(
    (resolve, reject) => {
      return data.json().then(
        data.ok?resolve:reject
      )
    }
  )
}

/**
 * Fetch JSON object using GET-request.
 * @async
 */
export function get(path) {
  return fetch(
    path,
    {
      "method": "GET",
      "headers" : headers
    }
  ).then(handler)
}

/**
 * Send POST-request and fetch JSON object in result.
 * @async
 */
export function post(path, data) {
  return fetch(
    path,
    {
      "method"  : "POST",
      "headers" : headers,
      "body"    : JSON.stringify(data)
    }
  ).then(handler)
}

api.get  = get
api.post = post

api.users = users

export default api;
